<template>
  <div>
    <div ref="instance" class="modal fade show" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >{{ $t('message.cancel') }}</button>
            <button
              :disabled="proccessing"
              type="button"
              class="btn btn-primary confirm-btn d-flex justify-content-center"
              @click="$emit('confirmed')"
            >
              {{ $t('message.ok') }}
              <span v-show="proccessing">
                <i class="spin-sm ml-4" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: {
    proccessing: {
      type: Boolean,
      default: false
    },
    confirmTitle: {
      type: String,
      default: ""
    }
  },
  created() {
    this.$nextTick(() => {
      let that = this;
      $(this.$refs.instance).modal("show");
      $(this.$refs.instance).on("hidden.bs.modal", function() {
        that.$emit("close");
      });
    });
  },
  computed: {
    title() {
      if (this.confirmTitle) return this.confirmTitle;
      else return this.$t("message.deleteCard");
    }
  },
  methods: {
    hideModal() {
      $(this.$refs.instance).modal("hide");
    }
  }
};
</script>
